/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "6a1d2b4de7d9389befccd728a6f6220a79bccf8e";
